import { render, staticRenderFns } from "./ElementTabs.vue?vue&type=template&id=5ca0d1c0&scoped=true"
import script from "./ElementTabs.vue?vue&type=script&lang=js"
export * from "./ElementTabs.vue?vue&type=script&lang=js"
import style0 from "./ElementTabs.vue?vue&type=style&index=0&id=5ca0d1c0&prod&lang=scss&scoped=true"
import style1 from "./ElementTabs.vue?vue&type=style&index=1&id=5ca0d1c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca0d1c0",
  null
  
)

export default component.exports